import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import main03 from '@static/image/main03.png';

interface IProps {
  show: boolean;
}
interface IState {}

const ListPage = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { show } = props;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="list-page">
      <section className="list-page-title">
        {show && <p>目录</p>}
        {show && (
          <img
            src={main03}
            alt=""/>
        )}
      </section>
    </section>
  );
};

export default observer(ListPage);
